/** Workspace an admin is currently viewing; null means their own workspace. */
let activeWorkspaceKey: string | null = null;

export const getActiveWorkspaceKey = () => activeWorkspaceKey;

export const setActiveWorkspaceKey = (workspaceKey: string | null) => {
  activeWorkspaceKey = workspaceKey;
};
